const messages = {
  step3: {
    actionBtn: "Aanmelden",
  },
};

export default {
  messages,
};
